import React from "react";
import { TestimonialsData } from "utils/TestimonialsData";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";

import nextArrow from "../../../assets/svg/rightArrow.svg";
import prevArrow from "../../../assets/svg/leftArrow.svg";
import TestimonialSVG from "utils/QuteSvg";

const swiperOptionstestimonials = {
  initialSlide: 0,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  autoHeight: true,
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    400: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 1.1,
    },
    750: {
      slidesPerView: 1.1,
    },
    992: {
      slidesPerView: 2.3,
    },
    1400: {
      slidesPerView: 4.1,
    },
  },
};

const Testimonials = () => {
  return (
    <div className="testimonialsSection">
      <h4 className="text-center py-3 mb-4 custom-testimonial-title main--title">
        Hear from our customers!
      </h4>
      <div className="categorySwiper homeSwipers">
        <Swiper
          {...swiperOptionstestimonials}
          spaceBetween={18}
          slidesPerView={1.1}
          // onSlideChange={() => console.log('slide change')}
          // onSwiper={(swiper) => console.log(swiper)}
        >
          {TestimonialsData.sort((a, b) => b.id - a.id).map((testimonial) => {
            return (
              <SwiperSlide className="testimonialSlide" key={testimonial.id}>
                <div className="testimonialWrapper">
                  <div className="backgroundSVG top-qoute">
                    <TestimonialSVG style={{ transform: "rotate(180deg)" }} />
                  </div>
                  <div className="testimonialContent">
                    <p className="testimonialText">{testimonial.testimonial}</p>
                    <small className="testimonialName">
                      {" "}
                      - {testimonial.customerName}
                    </small>
                  </div>
                  <div className="backgroundSVG bottom-qoute">
                    <TestimonialSVG />
                  </div>
                </div>
              </SwiperSlide>
            );
          })}

          <div className="swiper-button-next">
            <img src={nextArrow} alt="Arrow Right" />
          </div>
          <div className="swiper-button-prev">
            <img src={prevArrow} alt="Arrow Left" />
          </div>
        </Swiper>
      </div>
    </div>
  );
};

export default Testimonials;
